module.exports = __webpack_public_path__ + "images/emoji/mailbox.12427c6518b5d1eac798.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mailbox.png
// module id = 5hu0
// module chunks = 24